import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import { FANSITES_PAGE_URL, HOME_PAGE_URL } from '../../utils/constants/Routes';

// Data
import {
  fansitesPageAdditionalMeta,
  fansitesPageStructuredData,
} from '../../utils/data/MetaData';

// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import FansitesPageMainContainer from '../../components/fansites/FansitesPageMainContainer';

// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { fansitesPageFaqItems } from '../../utils/data/faqSchemas';

function FansitesPage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'Fansites', href: FANSITES_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Fansites'
        desc={`Unlock exclusive content from ${CompanyName}. Enter My premium fansites for private photos, videos, direct access, and deeper devotion.`}
        keywords={KeywordsPages}
        additionalMeta={fansitesPageAdditionalMeta}
        structuredData={[fansitesPageStructuredData, breadcrumbLd]}
        canonicalPath={FANSITES_PAGE_URL}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-8 lg:container lg:mx-auto lg:px-24'>
            <h1
              aria-label={`Fansites for ${CompanyName}`}
              className='text-center font-titleFont text-6xl lg:text-6xl tracking-widest'
            >
              Fansites
            </h1>

            <div className='mx-auto grid justify-center'>
              <h2 className='text-xl xs:text-2xl mt-1 sm:text-3xl md:text-4xl lg:text-4xl lg:py-2 text-center'>
                {CompanyTagLine}
              </h2>
            </div>

            <div className='grid h-fit gap-y-4 pt-6'>
              <p className='text-center text-lg max-w-2xl mx-auto'>
                Step deeper into My world by joining My fansites—where the real
                fun begins. From exclusive photos and videos to intimate
                sessions and direct messaging, each platform offers something
                deliciously different. Subscribing is your first act of
                devotion.
              </p>
            </div>
          </header>

          {/* Main page content */}
          <FansitesPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={fansitesPageFaqItems} />
      </div>
    </>
  );
}

export default FansitesPage;
